const accordionItems = document.querySelectorAll('.door-accordion-item');
if(accordionItems.length){
    accordionItems.forEach(item => {
        const header = item.querySelector('.door-accordion-header');

        header.addEventListener('click', () => {
            // Close all other items
            accordionItems.forEach(otherItem => {
            if (otherItem !== item) {
                otherItem.classList.remove('active');
            }
            });

            // Toggle current item
            item.classList.toggle('active');
        });
    });
}

function customPopup() {

  const btnShowPopup = document.querySelectorAll('.js-open-popup');
  const btnClosePopup = document.querySelectorAll('.js-close-popup');
  const popups = document.querySelectorAll('.js-custom-popup');

  // Open popup
  btnShowPopup.forEach(btn => {
    btn.addEventListener('click', function () {
      const targetPopup = this.getAttribute('data-target');
      const popup = document.querySelector('[data-popup="' + targetPopup + '"]');

      if (popup) {
        popup.classList.add('is-active');
      }
    });
  });

  // Close popup via close button
  btnClosePopup.forEach(btn => {
    btn.addEventListener('click', function () {
      const activePopup = this.closest('.is-active');
      if (activePopup) {
        activePopup.classList.remove('is-active');
      }
    });
  });

  // Close popup on outside click
  popups.forEach(popup => {
    popup.addEventListener('click', function (event) {
      if (
        !event.target.closest('.js-custom-popup-holder') &&
        !event.target.classList.contains('js-custom-popup')
      ) {
        popup.classList.remove('is-active');
      }
    });
  });

}

customPopup();
